/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* eslint-disable lines-between-class-members */
/**
 * Enumeration of resource types based on the structure of the configuration repository:
 *  - common for all procedures resources
 *  - generic for any resource
 *  - procedure specific resources
 *  - root level (critical) resources
 */
export class ResourceType {
  static COMMON = new ResourceType('COMMON');
  static GENERIC = new ResourceType('GENERIC');
  static PROCEDURE_SPECIFIC = new ResourceType('PROCEDURE_SPECIFIC');
  static ROOT = new ResourceType('ROOT');

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}
